import React, { useState, useEffect } from 'react';
import CrudPage from '../../components/CrudPage';
import { propertiesApi, propertiesTypeApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'propertyId' },
  { header: 'Name', field: 'propertyName' },
  { header: 'Price', field: 'price', render: (v) => v ? `£${v.toLocaleString()}` : '-' },
  { header: 'Type', field: 'propertyType', render: (v) => v?.propertyTypeName || '-' },
  { header: 'Archived', field: 'archived', render: (v) => v ? 'Yes' : 'No' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const PropertiesPage = () => {
  const [propertyTypes, setPropertyTypes] = useState([]);

  useEffect(() => {
    const fetchPropertyTypes = async () => {
      try {
        const response = await propertiesTypeApi.getAll();
        const types = response?.data?.[0] || response?.data || response || [];
        setPropertyTypes(Array.isArray(types) ? types : []);
      } catch (error) {
        console.error('Error fetching property types:', error);
      }
    };
    fetchPropertyTypes();
  }, []);

  const formFields = [
    { name: 'propertyName', label: 'Property Name', type: 'text', required: true },
    { name: 'price', label: 'Price', type: 'number', required: true },
    { name: 'description', label: 'Description', type: 'textarea' },
    { 
      name: 'propertyTypeId', 
      label: 'Property Type', 
      type: 'select',
      options: propertyTypes.map(pt => ({
        value: pt.propertyTypeId,
        label: pt.propertyTypeName
      })),
      getValue: (item) => item.propertyType?.propertyTypeId || item.propertyTypeId
    },
    { name: 'archived', label: 'Archived', type: 'checkbox' },
  ];

  return (
    <CrudPage
      title="Properties"
      subtitle="Manage all properties"
      api={propertiesApi}
      columns={columns}
      formFields={formFields}
      idField="propertyId"
      searchField="propertyName"
      addUrl="/admin/properties/add"
      viewUrl="/admin/properties/view"
      editUrl="/admin/properties/edit"
    />
  );
};

export default PropertiesPage;
